import { cn } from '@wellesley/ui'
import { GroupAppsLink } from '../GroupAppsLink'
import { AppsRoutes } from '@wellesley/router'

export type TagLabelSmallProps = {
  tag: string
  className?: string
  groupName?: string
}

export const TagLink = ({ tag, className, groupName }: TagLabelSmallProps) => {
  return (
    <GroupAppsLink
      to={'/g/:groupname/forum/tags/:tagName' as AppsRoutes}
      props={{ tagName: tag }}
      onClick={(e) => e.stopPropagation()}
      groupName={groupName}
    >
      <span
        className={cn(
          'text-sm font-medium text-blue-500 hover:underline',
          className,
        )}
      >
        {tag}
      </span>
    </GroupAppsLink>
  )
}
